"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareMiddlewarePipelinePayload = void 0;

var _NotAMiddleware = require("../lib/Exceptions/NotAMiddleware");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var prepareMiddlewarePipelinePayload = function prepareMiddlewarePipelinePayload(x) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!Array.isArray(arr)) {
    throw new _NotAMiddleware.NotAMiddleware();
  } else {
    var allMiddlewares = arr.every(function (a) {
      return typeof a === 'function';
    });

    if (!allMiddlewares) {
      throw new _NotAMiddleware.NotAMiddleware();
    }
  }

  if (Array.isArray(x)) {
    if (x.length < 1) {
      return _toConsumableArray(arr);
    }

    var _allMiddlewares = x.every(function (_x) {
      return typeof _x === 'function';
    });

    if (_allMiddlewares) {
      return [].concat(_toConsumableArray(arr), _toConsumableArray(x));
    }

    throw new _NotAMiddleware.NotAMiddleware();
  }

  if (typeof x === 'function') {
    arr.push(x);
  } else {
    throw new _NotAMiddleware.NotAMiddleware();
  }

  return arr;
};

exports.prepareMiddlewarePipelinePayload = prepareMiddlewarePipelinePayload;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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